module.exports = {
  "@primary-color":"#2C367A",
  "@link-color":"#2C367A",
  "@redMain":"#8690ad",
  "@greyDark":"#35383C"
};
